import { register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './play-pause-animation.css'

const ANIMATION_MS = 500

@register
export class PlayPauseAnimation extends BaseComponent {
  declare animationInActionId?: ReturnType<typeof this.setTimeout>

  constructor(player, options) {
    super(player, options)

    /* Methods from this component is used by reference in player */
    ;(player as any).playPauseAnimation = this
  }

  animate(paused?: boolean) {
    const isPaused = paused !== undefined ? paused : this.player_.paused()

    /* Toggles and animates play/pause
     * so use with user input, when no errors, or content switching
     */
    this.player_.removeClass('x-animate-play')
    this.player_.removeClass('x-animate-pause')

    /* animationInActionId existence means that animation is on the screen */
    if (this.animationInActionId) {
      this.clearTimeout(this.animationInActionId)
      this.animationInActionId = undefined
    }

    if (isPaused) {
      this.requestAnimationFrame(() => this.player_.addClass('x-animate-play'))
    } else {
      this.requestAnimationFrame(() => this.player_.addClass('x-animate-pause'))
    }

    this.animationInActionId = this.setTimeout(() => {
      this.player_.removeClass('x-animate-play')
      this.player_.removeClass('x-animate-pause')
      this.animationInActionId = undefined
    }, ANIMATION_MS)
  }
}

PlayPauseAnimation.options = {
  className: 'vjs-x-animation-play-pause',
}
